import React from "react";
import "./css/Footer.css";

export default function Footer() {
    const currentYear = new Date().getFullYear();
    
    return (
        <footer className="footer">
            <div className="footer-content">
                <p className="copyright">
                    © {currentYear} All rights reserved. Made with ❤️ by <span className="name-highlight">Ranilbala B</span>
                </p>
            </div>
        </footer>
    );
}
